module.exports = __webpack_public_path__ + "img/avatar7.e68b3f0e.png";